// extracted by mini-css-extract-plugin
export default {"name":"hz-layouts-auth-layout-components-header-index-name","down":"hz-layouts-auth-layout-components-header-index-down","help":"hz-layouts-auth-layout-components-header-index-help"};